import './HomePage.css';
import SEO from '../../components/SEO/SEO';
import CarouselItem from '../../components/CarouselItem/CarouselItem';
import ContactForm from '../../components/ContactForm/ContactForm';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FeedbackItem from '../../components/FeedbackItem/FeedbackItem';
import { 
    faUtensils, 
    faCalendarAlt,
    faArrowRight, 
    faEnvelope,
    faPhone,
    faTimes,
    faSpinner
} from '@fortawesome/free-solid-svg-icons';
import ScrollReveal from '../../components/ScrollAnimation/ScrollReveal';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ApiService } from '../../services/api.service';
import { getBackendImageUrl } from '../../utils/imageUtils';

function HomePage() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [mainMenu, setMainMenu] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMainMenu = async () => {
            try {
                setIsLoading(true);
                setError(null);
                const response = await ApiService.getMenuItemsByTitle('main');
                setMainMenu(response);
            } catch (err) {
                console.error('Erreur lors du chargement du menu:', err);
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchMainMenu();
    }, []);
    return (
      <>
        <SEO 
          title="Accueil"
          description="Découvrez Tours Bouillon, restaurant gastronomique à Tours. Cuisine française traditionnelle, ambiance chaleureuse et service d'exception. Réservez votre table en ligne."
          keywords="restaurant Tours, gastronomie Tours, cuisine française, restaurant centre-ville Tours, réservation restaurant, Tours Bouillon"
          url="/"
        />
        <div className="hero"></div>
        
        {/* <ScrollReveal animation="fade-down">
          <div className="site-title">
            <span>TOURS</span>
            <div className="title-line"></div>
            <span>BOUILLON</span>
          </div>
        </ScrollReveal> */}

       

        <ScrollReveal animation="fade-up">
          <div className='background-brown'>
            <div className='container'>
              <div className='menu-section'>
                <div className='menu-content'>
                  <div className='menu-header'>
                    <h2>Notre Menu</h2>
                    <p className='menu-subtitle'>Une cuisine raffinée et authentique</p>
                  </div>
                  
                  <div className='menu-info-grid'>
                    <div className='menu-info-card'>
                      <FontAwesomeIcon icon={faUtensils} className="fa-icon" />
                      <div className='info-content'>
                        <h3>Plat du Jour</h3>
                        <p>Voir ardoise</p>
                      </div>
                    </div>
                    
                    <div className='menu-info-card'>
                      <FontAwesomeIcon icon={faCalendarAlt} className="fa-icon" />
                      <div className='info-content'>
                        <h3>Mise à Jour</h3>
                        <p>Menu actualisé chaque semaine</p>
                      </div>
                    </div>
                  </div>

                  <Link to='/menu' className='view-menu-btn' style={{textDecoration: 'none'}}>
                    <div>Découvrir notre carte</div>
                    <FontAwesomeIcon icon={faArrowRight} className="fa-icon" />
                  </Link>
                </div>

                <div className='menu-visual'>
                  {isLoading ? (
                    <div className="menu-loading">
                      <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                      <p>Chargement du menu...</p>
                    </div>
                  ) : error ? (
                    <div className="menu-error">
                      <p>{error}</p>
                      <button onClick={() => window.location.reload()} className="retry-button">
                        Réessayer
                      </button>
                    </div>
                  ) : (
                    <div className='menu-card' onClick={() => setSelectedImage(getBackendImageUrl(mainMenu?.path))}>
                      <img src={getBackendImageUrl(mainMenu?.path)} alt="Menu du restaurant" />
                      <div className='menu-card-overlay'></div>
                    </div>
                  )}
                  <div className='floating-elements'>
                    <div className='floating-circle'></div>
                    <div className='floating-line'></div>
                    <div className='floating-dots'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal animation="fade-up">
          <section className='container presentation-section'>
            <div className='image-test-section'>
              <img src='/images/20250125_121812.jpg'/>
              <div className='vertical-line'>
                <div className='decorator-top'></div>
                <div className='decorator-bottom'></div>
              </div>
              <div className='text-section-item'>
                <h2>Une Cuisine Locale, Fraîche et de Saison</h2>
                <p>Le ToursBouillon est un restaurant traditionnel français qui propose une cuisine de saison dans une ambiance conviviale. Avec une carte courte qui évolue selon les arrivages du marché, le restaurant mise sur la fraîcheur et la simplicité. Ouvert du mardi au samedi pour le déjeuner, il accueille aussi les clients en soirée les jeudis et vendredis, et peut être privatisé pour des événements intimistes. C’est une adresse chaleureuse, idéale pour un repas décontracté et savoureux. </p>
                <Link to='/about'>A propos</Link>
              </div>
            </div>
          </section>
        </ScrollReveal>

        <ScrollReveal animation="fade-up">
          <div className='background-dark-gray'>
            <div className='container'>
              <div className='contact-header'>
                <h2 style={{color: 'black'}}>BOISSONS</h2>
              </div>

              <div className='brew_display'>
                <Link to='/menu?menu=Vins' style={{textDecoration: 'none'}}><CarouselItem name="Vins" color="white" backgroundImage="/images/image_vins.png"/></Link>
                <Link to='/menu?menu=Soft' style={{textDecoration: 'none'}}><CarouselItem name="Softs" color="black" backgroundImage="/images/glass-4531446_1280.jpg"/></Link>
                <Link to='/menu?menu=Spiritueux' style={{textDecoration: 'none'}}><CarouselItem name="Boissons alcoolisées" color="white" backgroundImage="/images/beer-7884160_1280.jpg"/></Link>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal animation="zoom-in">
          <div className='feed-section'>
            <div className='container'>
              <div className='title-wrapper'>
                <h2>AVIS</h2>
                <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='avis-img-bck'>
                  <path d="M12.9 0C5.8 3.8 0 10.4 0 17.3C0 21.3 2.7 24 6.7 24C10.4 24 13.4 21 13.4 17.3C13.4 13.9 10.7 11.2 7.3 11.2C6.5 11.2 5.8 11.3 5.1 11.6C6.4 7.2 10.2 3.5 14.5 1.3L12.9 0Z" fill="#D4B08C"/>
                  <path d="M30.4 0C23.3 3.8 17.5 10.4 17.5 17.3C17.5 21.3 20.2 24 24.2 24C27.9 24 30.9 21 30.9 17.3C30.9 13.9 28.2 11.2 24.8 11.2C24 11.2 23.3 11.3 22.6 11.6C23.9 7.2 27.7 3.5 32 1.3L30.4 0Z" fill="#D4B08C"/>
                </svg>
              </div>
              <div className='feedbacks-container'>
                <FeedbackItem name="Ornela Uca" stars={5} comment="Bien installées au soleil, mon amie et moi avons pu profiter d’un moment délicieux au Tours Bouillon. Au menu : lieu noir et risotto au chorizo, des saveurs en totale adéquation avec la météo du jour, pour réchauffeur nos cœurs et nos estomacs. Merci à Romain pour l'accueil et à Lucie pour la cuisine !" />
                <FeedbackItem name="geoffrey poisson" stars={5} comment="Superbe accueil ! Superbe cuisine faites maison avec des produits frais ! Bravo ." />
                <FeedbackItem name="Margot Capitelli" stars={5} comment="Venue un soir de semaine pour un apéritif entre amis, très chaleureusement reçue, c’est cette raison qui m’a donné envie de revenir dès le lendemain pour un déjeuner au soleil.
Les plats sont frais et de qualité, je recommande !" />
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal animation="fade-up">
          <section className="home-contact-section">
            <div className="container">
              <div className="contact-header">
                <h2>CONTACT</h2>
                <p className="contact-subtitle">Une question ? N'hésitez pas à nous contacter</p>
              </div>
              
              <div className="contact-content">
                <div className="contact-info">
                  <div className="contact-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="contact-details">
                    <h3>Contactez-nous</h3>
                    <p>Notre équipe vous répondra dans les plus brefs délais</p>
                    <div className="contact-links">
                      <a href="tel:0247205060">
                        <FontAwesomeIcon icon={faPhone} />
                        02 47 20 50 60
                      </a>
                      <a href="mailto:toursbouillon@gmail.com">
                        <FontAwesomeIcon icon={faEnvelope} />
                        toursbouillon@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
                
                <div className="contact-form-wrapper">
                  <ContactForm />
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {selectedImage && (
            <div className="lightbox" onClick={() => setSelectedImage(null)}>
                <button className="close-button" onClick={() => setSelectedImage(null)}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <img src={selectedImage} alt="Menu du restaurant" />
            </div>
        )}
      </>
    );
  }
  
export default HomePage;
  